import { Box } from "@mui/material";
import ScrollTopButton from "components/ScrollTopButton";
import { ComponentType, RefObject } from "react";

interface WithHeightFitContentParams {
  refProp: RefObject<HTMLDivElement>;
}

const withHeightFitContent = <T extends object>(Component: ComponentType<T>) => {
  // eslint-disable-next-line react/function-component-definition, react/display-name
  return ({ refProp: ref, ...props }: T & WithHeightFitContentParams) => {
    return (
      <>
        <Box
          ref={ref}
          sx={{
            height: "100%",
            maxHeight: `calc(100vh - ${ref?.current?.getBoundingClientRect()?.top || 0}px - 50px)`,
            overflowY: "auto",
            overflowX: "hidden",
          }}>
          <Component {...(props as T)} />
        </Box>
        <ScrollTopButton
          threshold={400}
          scrollIntoRef={ref}
        />
      </>
    );
  };
};

export default withHeightFitContent;
